import CHEM_RENDERERS from './chemicalFormula.js';
import SI_RENDERERS from './siunits.js';
const EXT_RENDERERS = Object.assign(Object.assign({}, CHEM_RENDERERS), SI_RENDERERS);
export default EXT_RENDERERS;
